import { Icon } from '@fluentui/react';
import Moment from 'moment';
import { useTranslation } from "react-i18next";
const ColumnsModality = () =>{
    const paddingHeader = "15px 15px";
    const paddingChild = "0px 15px 0px 15px";
    const widthStyle = "20vw";
    const [t, i18n] = useTranslation();
    return [
      {
        id: t("modality.column.name"),
        style: {width: widthStyle, padding: paddingChild,boxSizing:'border-box' },
        headerStyle: {padding:paddingHeader, textAlign: "left",boxSizing:'border-box', width: widthStyle},
        headerClass:"break-word",
        classChildName:
            "break-word",
        header: () => (
          <>{t("modality.column.name")}</>
        ),
        accessor: t("modality.column.name"),
        accessorKey: t("modality.column.name"),
        show: true,
        cell: (info) =>  <>
            <div className="user-sub-heading">{info.row.original.name}</div>
      </>
      },
      {
        id: t("modality.column.description"),
        style: {width: widthStyle, padding: paddingChild,boxSizing:'border-box' },
        headerStyle: {padding:paddingHeader, textAlign: "left",boxSizing:'border-box', width: widthStyle},
        headerClass:"break-word",
        classChildName:
            "break-word",
        header: () => (
          <>{t("modality.column.description")}</>
        ),
        accessor: t("modality.column.description"),
        accessorKey: t("modality.column.description"),
        show: true,
        cell: (info) =>  <>
            <div className="user-sub-heading">{info.row.original.description}</div>
      </>
      }
    ];
  };
export default ColumnsModality;
